const locale = {
  placeholder: 'Selectează ora',
};

export default locale;
